import React, { memo } from 'react';
import productParameterConfigs from './config';
import ProductParameterEditor from './ProductParameterEditor';
function ProductEventEditor({ create = false }) {
    return React.createElement(ProductParameterEditor, { config: productParameterConfigs.events, create: create });
}
export default memo(ProductEventEditor);
